<script>
import { columns } from './help'
import BlacklistOperationForm
  from "./components/BlacklistOperationForm.vue";
import {
  downloadTemplate, exportBlackList, exportSignAgreementFile,
  insertBlackList,
  removeBlackListById,
  editBlackList,
  selectBlackList, getBlackListDetailsById
} from "@/api/activityRegistration";
export default {
  name: 'BlacklistManagement',
  components: {BlacklistOperationForm},
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.status !== 0 && record.status !== 1
          },
        }),
      };
    },
  },
  data() {
    return {
      columns,
      dataInfo: [],
      selectedRowKeys: [],
      upload: {
        // 设置上传的请求头部
        headers: { Authorization: JSON.parse(localStorage.getItem("user")).accessToken },
      },
      searchForm: {
        //  用户ID
        userId: '',
        //  手机号
        mobile: '',
        // 姓名
        userName: '',
        // 状态
        status: undefined,
        // 黑名单时间
        blackListTime: undefined,
      },
      // 状态List
      statusList: [
          {
            value: 0,
            label: "正常"
          },
          {
            value: 1,
            label: "待生效"
          },
          {
            value: 2,
            label: "已移除（人工）"
          },
          {
            value: 3,
            label: "已移除（到期）"
          }
      ],
      //分页数据
      pagination: {
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
        showTotal: (total) => {
          return `共 ${total} 条`;
        },
      },
      // 操作类型
      operationType: 'add',
      // 弹窗
      visibleModal: false,
      // 弹窗确认loading
      confirmLoading: false,
      // 当前操作项
      operationData: {},
    }
  },
  async created() {
    // 获取黑名单列表
    await this.getBlackList();
  },
  methods: {
    /**
     * @Description：导入黑名单
     * @Author cxd
     * @Date 2026/1/14 10:17
     */
    handleChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        if (info.file.response && info.file.response.code === 200) {
          this.$message.success(info.file.response.data);
          this.getBlackList()
        } else {
          this.$message.error(info.file.response.msg)
        }
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败`);
      }
    },
    /**
     * @Description：黑名单列表
     * @Author cxd
     * @Date 2026/1/4 16:29
     */
    async getBlackList() {
      const params = this.getParams()
      const res = await selectBlackList(params);
      const { code, data, msg } = res;
      if (code === 200) {
        
        this.dataInfo = data.items
        this.pagination.total = data.total;
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * @Description：整理检索参数
     * @Author cxd
     * @Date 2026/1/12 14:12
     */
    getParams () {
      let params = {
        ...this.searchForm,
        blackDateStart: this.searchForm.blackListTime?this.searchForm.blackListTime[0]:undefined,
        blackDateEnd: this.searchForm.blackListTime?this.searchForm.blackListTime[1]:undefined,
        paging:{
          page:this.pagination.current,
          size:this.pagination.pageSize,
        }
      };
      delete params.blackListTime;
      return params
    },
    /**
     * @Description：检索
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    search() {
      this.pagination.current=1;
      this.pagination.pageSize=10;
      this.getBlackList()
    },
    /**
     * @Description：重置
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    resetSearchForm() {
      this.searchForm = this.$options.data().searchForm;
      this.getBlackList()
    },
    /**
     * @Description：新建黑名单
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    addBlacklist() {
      this.operationType = 'add';
      this.operationData = {};
      this.visibleModal = true;
    },
    /**
     * @Description：移除
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    removeItems() {
      this.removeBlackList(this.selectedRowKeys,true);
    },
    /**
     * @Description：下载模版
     * @Author cxd
     * @Date 2026/1/12 14:27
     */
    async downloadTemplate() {
      const res = await downloadTemplate();
      // const url = window.URL.createObjectURL(new Blob([res.data]))
      let blob = new Blob([res.data]);
      // let now = new Date();
      // let formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      let name = '活动黑名单模版' + '.xlsx';
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = name
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, name)
      }
      this.$message({
          message: '导出成功',
          type: 'success'
        });
    },
    /**
     * @Description：分页操作
     * @Author cxd
     * @Date 2026/1/4 16:28
     */
    //分页操作
    pageChange(option) {
      this.pagination.current = option.current;
      this.pagination.pageSize = option.pageSize;
      this.getBlackList();
    },
    /**
     * @Description：弹窗确认事件
     * @Author cxd
     * @Date 2026/1/4 16:50
     */
    handleOk() {
      this.$refs.blacklistOperationForm.onSubmit()
    },
    /**
     * @Description：弹窗取消操作
     * @Author cxd
     * @Date 2026/1/4 16:51
     */
    handleCancel() {
      this.visibleModal = false;
    },
    /**
     * @Description：添加黑名单
     * @Author cxd
     * @Date 2026/1/12 15:38
     */
    async addBlackList(params) {
      try {
        this.confirmLoading = true;

        const res = this.operationType==='edit'? await editBlackList(params) : await insertBlackList(params)
        if (res.code === 200) {
          this.$message.success(res.msg);
          await this.getBlackList();
          this.visibleModal = false;
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e.msg)
      } finally {
        this.confirmLoading = false
      }
    },
    /**
     * @Description：移除黑名单
     * @Author cxd
     * @Date 2026/1/12 15:43
     */
    async removeBlackList(row,type) {
      const that = this
      const params = { id: type?row:[row.id] };
      this.$confirm({
        title: '移除后用户可正常报名活动，是否确认把用户从黑名单移除？',
        onOk() {
          removeBlackListById(params).then(res => {
            if (res.code === 200) {
              that.$message.success('操作成功');
              that.selectedRowKeys=[];
              that.getBlackList();
            } else  {
              that.$message.error('操作失败')
            }
          })
        },
        onCancel() {},
      })
    },
    /**
     * @Description：导出
     * @Author cxd
     * @Date 2026/1/12 15:50
     */
    async exportData() {
      const params = this.getParams()
      try {
        const res = await exportBlackList(params)
        const blob = new Blob([res.data]);
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.setAttribute("download", "活动报名黑名单.xlsx");
        a.click();
        this.visibleSignAgreement = false
      } catch(err) {
        this.$message.error('导出失败')
      }
    },
    /**
     * @Description：表格多选中事件
     * @Author cxd
     * @Date 2026/1/12 16:52
     */
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    /**
     * @Description：编辑
     * @Author cxd
     * @Date 2026/1/4 16:20
     */
    edit(row) {
      this.operationType = 'edit';
      // 查询详情
      getBlackListDetailsById(row.id).then(res => {
          if (res.code === 200) {
            this.operationData = res.data;
            this.visibleModal = true;
          }
      })
    },
  }
}
</script>

<template>
  <div class="black-list-main">
    <ds-header title="活动黑名单"></ds-header>
    <a-form layout="inline">
      <a-form-item label="用户ID：">
        <a-input v-model.trim="searchForm.userId" placeholder="请输入用户ID" class="inputClass" />
      </a-form-item>
      <a-form-item label="手机号：">
        <a-input v-model.trim="searchForm.mobile" placeholder="请输入手机号" class="inputClass" />
      </a-form-item>
      <a-form-item label="姓名：">
        <a-input v-model.trim="searchForm.userName" placeholder="请输入姓名" class="inputClass" />
      </a-form-item>
      <a-form-item label="状态：">
        <a-select  placeholder="请选择状态" v-model="searchForm.status" style="width: 200px">
          <a-select-option v-for="(item, index) in statusList" :key="index" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="黑名单时间：">
        <a-range-picker
            show-time
            v-model="searchForm.blackListTime"
            format="YYYY-MM-DD HH:mm:ss"
        >
        </a-range-picker>
      </a-form-item>
      <span>
        <a-button type="primary" @click="search" style="margin-top: 3px"> <a-icon type="search" />查询 </a-button>
        <a-button style="margin-left: 15px" @click="resetSearchForm">重置</a-button>
      </span>
    </a-form>
    <div style="padding-top: 15px">
      <a-button type="primary" @click="addBlacklist()"> <a-icon type="plus" />添加</a-button>
      <a-button style="margin-left: 15px" type="primary" @click="exportData()"> <a-icon type="export" />导出</a-button>
      <a-button style="margin-left: 15px" :disabled="selectedRowKeys && selectedRowKeys.length === 0" type="primary" @click="removeItems()"> <a-icon type="delete" />移除</a-button>
      <a-upload
          style="margin-left: 15px"
          name="file"
          accept=".xlsx, .xls"
          action="/api/dscloud-app-forum/web/activityInformation/user/black/import"
          :headers="upload.headers"
          :showUploadList="false"
          @change="handleChange"
      >
        <a-button
            type="primary"
        >
          <a-icon type="import" /> 导入名单
        </a-button>
      </a-upload>
      <a-button style="margin-left: 15px" type="link" @click="downloadTemplate()"> <a-icon type="download" />下载模版</a-button>
    </div>
    <div style="margin-top: 15px">
      <a-table
          :rowKey="(record, index) => record.id"
          :columns="columns"
          :data-source="dataInfo"
          :pagination="pagination.total ? pagination : false"
          @change="pageChange"
          bordered
          :scroll="{ x: 1500 }"
          :row-selection="rowSelection"
      >
        <span slot="content" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.content }}</template>
            <span class="field">{{ record.content }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record" class="action">
          <a-button class="btnClass" type="link" @click="edit(record)"> 编辑 </a-button>
          <a-button v-if="record.status === 0 || record.status === 1" class="btnClass" type="link" @click="removeBlackList(record)" > 移除 </a-button>
        </span>
      </a-table>
    </div>
    <a-modal
        :title="operationType === 'add' ? '添加' : '编辑'"
        :visible="visibleModal"
        :confirm-loading="confirmLoading"
        destroyOnClose
        width="600px"
        @ok="handleOk"
        @cancel="handleCancel"
        :maskClosable="false"
    >
      <blacklist-operation-form
          ref="blacklistOperationForm"
          :operationData="operationData"
          :operationType="operationType"
          @addBlackList="addBlackList"
      />
    </a-modal>
  </div>
</template>

<style scoped lang="scss">
.field {
  font-size: 12px;
  display: inline-block;
  height: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}
</style>